export default __webpack_public_path__ + "static/045-44d6a323f884e39fcd8e33a085efe0c5.jpg";